import { Application, FeathersService, Query, Service } from "@feathersjs/feathers";
import { makeObservable, reaction, when } from "mobx";
import client from "src/feathers";
import { Agenda } from "src/models/agenda";
import { RootStore, BaseDataStore } from ".";
import { DataType, IAgenda, IAgendaSpace } from "../types";


export class AgendaStore extends BaseDataStore<Agenda, IAgenda> {
  protected readonly space_link_service: FeathersService<Application<IAgendaSpace>, Service<IAgendaSpace>> = client.service("agenda-space");

  constructor(readonly rootStore: RootStore) {
    super(rootStore, Agenda.create, DataType.Agenda);

    makeObservable(this, {
    });

    // Link event listener
    this.space_link_service.on("created", (data: IAgendaSpace) => {
      if(!this.container[Number(data.agenda_id)]) return;

      this.updateContainerEntry(
        Number(data.agenda_id), 
        "spaces", 
        this.container[Number(data.agenda_id)].spaces.concat(Number(data.space_id))
      );
    });
    this.space_link_service.on("removed", (data: IAgendaSpace) => {
      if(!this.container[Number(data.agenda_id)]) return;
      this.updateContainerEntry(
        Number(data.agenda_id), 
        "spaces", 
        this.container[Number(data.agenda_id)].spaces.filter(a => a !== Number(data.space_id))
      );
    });
  }

  /*******************************************************************************************************************************************
   * Overwrites
   ********************************************************************************************************************************************/
  init() {
    super.init();
    // Load initial data on login:
    when(() => this.rootStore.authStore.isLoggedIn, () => {
      this.loadItems(this.getCurFilter());
    }, {name: "agenda_login_load"});

    // Setup reactions
    reaction(() => this.rootStore.authStore.getCurWorkspaceID, () => {
      if(this.rootStore.authStore.getCurWorkspaceID) this.loadItems(this.getCurFilter());
    }, {name: "agenda_change_workspace"});
  }
  protected getCurFilter = (): Query => ({
  });

  /*******************************************************************************************************************************************
   * Getter 
   ********************************************************************************************************************************************/

  /*******************************************************************************************************************************************
   * Setter 
   ********************************************************************************************************************************************/

  /*******************************************************************************************************************************************
   * Actions
   ********************************************************************************************************************************************/
}

